import { userConstants } from './../constants/user.constants';

const initialState = {};

export function Onhold(state = initialState, action) {
  switch (action.type) {
    case userConstants.ONHOLD_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.ONHOLD_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.ONHOLD_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}